import { React, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import MainRouter from "./Component/cabBooking/routes/MainRouter";
import css from "./Component/assets/css/style.css";
import css2 from "./Component/assets/css/bootstrap.css";
import css3 from "./Component/assets/css/responsive.css";
import useSettings from "./Component/cabBooking/hooks/useSettings";
import useLanguage from "./Component/cabBooking/hooks/useLanguage";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import RideDeatilsProvider from "./Component/cabBooking/context/RideDeatils";
import CardDeatilsProvider from "./Component/cabBooking/context/CardDeatilsContext";
import socketIO from "socket.io-client";
import useSocket from "./Component/cabBooking/hooks/useSocket";
import { Loader } from "@googlemaps/js-api-loader";
import { SmallLoader } from "./Component/cabBooking/common/SmallLoader";
// const { settings, fetchSettings } = useSettings();
// import css4 from "./Component/assets/css/font-awesome.min.css";
// import Notification from "./Component/cabBooking/home/Notification";
// function App() {
//   const { settings, fetchSettings } = useSettings();

//   const fetchingSettings = async () => await fetchSettings();
//   useEffect(() => {
//     fetchingSettings();
//   }, []);

//   useEffect(() => {
//     alert(JSON.stringify(1));
//     alert(JSON.stringify(settings));
//   }, [settings]);

//   // const fetchingBasicThings = async () => {
//   //   const { data } = await fetchingSettings();
//   //   if (data) {
//   //     data.languageDirection === "RTL" ? alignRight() : alignLeft();
//   //   }
//   //   if (data && data.languageCode) await fetchingLanguage(data.languageCode);
//   // };
//   return (
//     <div>
//       <MainRouter />
//     </div>
//   );
// }

// export default App;

export default function App() {
  const { settings, fetchSettings } = useSettings();
  const { language, fetchLanguage } = useLanguage();
  const [loading, setLoading] = useState(true);

  const { notificationSocket } = useSocket();

  const fetchingSettings = async () => await fetchSettings();
  const fetchingLanguage = async (lang, clientId) =>
    await fetchLanguage(lang, clientId);

  const fetchingBasicThings = async () => {
    const { data } = await fetchingSettings();
    // if (data) {
    //   data.languageDirection === "RTL" ? alignRight() : alignLeft();
    // }
    // {alert(data.languageCode)}
    if (data && data.languageCode)
      await fetchingLanguage(data.languageCode, data?.clientId);
    // if (data && data.languageCode) await fetchingLanguage("pt-br");
    // if (data && data.languageCode) await fetchingLanguage("ta");
    // if (data && data.clientId) await fetchingMapSettings(data.clientId);
    setLoading(false);
  };

  useEffect(() => {
    // const fetchingBasicThings = async () => {
    //   const { data } = await fetchSettings();
    //   alert("data");
    //   alert(data);
    // };
    fetchSettings();
    fetchingBasicThings();
  }, []);

  useEffect(() => {
    if (settings != null) {
      // alert(JSON.stringify(1));
      // alert(JSON.stringify(settings));
      // console.log("settings");
      // console.log(settings);
      // console.log("settings");
    }
  }, []);
  useEffect(() => {
    // console.log("------------");
    // console.log(settings);
    // console.log("------------");
    if (settings !== null && settings?.mapApi?.web) {
      // console.log(JSON.stringify(settings));
      const loader = new Loader({
        apiKey: settings?.mapApi?.web,
        // apiKey: "AIzaSyBbdeSXbRBE0Ts6G8q4XR0uoa8o5KYlnDI",
        version: "weekly",
        libraries: ["places"],
      });
      loader
        .load()
        .then(() => {
          // setGoogleLoaded(true);
        })
        .catch((e) => {});
    }
  }, [settings, settings?.mapApi?.web]);

  // useEffect(() => console.log(notificationSocket), [notificationSocket]);

  // useEffect(() => {
  //   console.log("Profile");
  //   console.log(notificationSocket);
  //   if (notificationSocket.connected) {
  //     console.log("notificationSocket_______1");

  //     notificationSocket.current.on(
  //       "trackBookingStatusForWebBookingApp",
  //       (data) => {
  //         console.log(JSON.stringify(data));
  //       }
  //     );
  //     console.log("notificationSocket_______2");
  //   }
  // }, [notificationSocket]);

  // fetchSettings();

  // const fetchingBasicThings = async () => {
  //   const { data } = await fetchingSettings();
  //   if (data) {
  //     data.languageDirection === "RTL" ? alignRight() : alignLeft();
  //   }
  //   if (data && data.languageCode) await fetchingLanguage(data.languageCode);
  // };
  return (
    <div>
      {loading ? (
        <div
          className="flex justify-center items-center w-full h-screen"
          //className={`${themeT.colors.button} rounded-lg px-16 py-0 mt-2 h-[40px]`}
        >
          <div role="status">
            <svg
              aria-hidden="true"
              class={` w-7 h-7 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600`}
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <RideDeatilsProvider>
          <CardDeatilsProvider>
            <MainRouter />
          </CardDeatilsProvider>
        </RideDeatilsProvider>
      )}
    </div>
  );
}
